import script from "./FooterToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterToolbar.vue?vue&type=script&setup=true&lang=js"

import "./FooterToolbar.vue?vue&type=style&index=0&id=d6a278dc&lang=css"

const __exports__ = script;

export default __exports__